import React from "react";
import useSPPosition from "../../hooks/useSPPosition";
import useSPUndo from "../../hooks/useSPUndo";
import { handleInputSelect, addEdits } from "./utils/inputhandlers";
import SearchField from "../SearchField/SearchField";

const PositionsSPPackaging = ({ clearfield }) => {
  // Load context values
  const { SPposition, setSPposition, setSPpositionData } = useSPPosition();
  const { positionEditsSP, editIDSP, setEditIDSP, undoListSP } = useSPUndo();

  // Local function to allow shorthand input property for onItemSelect
  const localHandleInputSelect = (item, origin, destination) => {
    handleInputSelect(
      item,
      positionEditsSP,
      editIDSP,
      setEditIDSP,
      setSPposition,
      setSPpositionData,
      addEdits,
      undoListSP,
      origin,
      destination
    );
  };
  return (
    <fieldset>
      <legend>Packaging:</legend>
      <div className='form-group'>
        <label>BagSize:</label>
        <SearchField
          required={true}
          searchURL='/api/positions/getbagsizes'
          value={SPposition.bagSize || ""}
          valueName='bagSize'
          valueID='bagSizeID'
          customplaceholder='bagSize'
          onItemSelect={(item) => {
            localHandleInputSelect(item, "bagSize", "bagSize");
          }}
          clearfield={clearfield}
        />
      </div>
      <div className='form-group'>
        <label>Marks:</label>
        <SearchField
          required={true}
          searchURL='/api/positions/getbagmarktypes'
          value={SPposition.bagMarkType || ""}
          valueName='bagMarkType'
          valueID='bagMarkTypeID'
          customplaceholder='bagMarks...'
          onItemSelect={(item) => {
            localHandleInputSelect(item, "bagMarkType", "bagMarkType");
          }}
          clearfield={clearfield}
        />
      </div>
    </fieldset>
  );
};

export default PositionsSPPackaging;
